import React from "react";
export const TypeContext = React.createContext<"collection" | "search" | "instant-search" | "">("");
